import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CustomerNoteService } from './note.service';
import { CustomerNote } from '../../candidates/notes/note.interface';
const service = new CustomerNoteService();

export interface CustomerNoteState {}

const CustomerNoteStore: Module<CustomerNoteState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async post(context, { id, note }: { id: number; note: CustomerNote }) {
         const response = await service.post(id, note);
         return response;
      },
      async put(context, { id, note, noteId }: { id: number; note: CustomerNote; noteId: number }) {
         const response = await service.put(id, noteId, note);
         return response;
      },
      async delete(context, { customer_id, id }: { customer_id: number; id: number }) {
         const response = await service.delete(customer_id, id);
         return response;
      },
   },
};

export default CustomerNoteStore;
